import { render, staticRenderFns } from "./tabItem.vue?vue&type=template&id=d3a4e8d6&functional=true&"
import script from "./tabItem.vue?vue&type=script&lang=js&"
export * from "./tabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_uc55t47uxtlogncefk63ylt2rm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports